module.exports = __webpack_public_path__ + "img/openbadge-type-5.b3bfabd3.png";